import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { detectCardBrand, formatCardNumber, luhnCheck } from "../../../api/utils/cardUtils";

function CreditCardInput({ name, formik, label = "" }) {
    const [cardBrand, setCardBrand] = useState(null);
    const handleChange = (e) => {
        let value = e.target.value.replace(/\D/g, ""); // remove non-digits

        // Detect brand
        const brand = detectCardBrand(value);

        // 🔥 LIMIT CARD NUMBER LENGTH BASED ON BRAND
        if (brand) {
            const maxLength = Math.max(...brand.validLengths);
            value = value.slice(0, maxLength);
        } else {
            value = value.slice(0, 19); // Generic max (Visa 19)
        }

        // Set brand
        if (brand?.name !== cardBrand?.name) {
            formik.setFieldValue("cvv", ""); // 🔥 clear CVV when brand changes
            formik.setFieldError("cvv", "");          // 🔥 remove CVV error
            // formik.setFieldTouched("cvv", false);
        }

        setCardBrand(brand);
        formik.setFieldValue("cardBrand", brand);

        // Mask formatting (xxxx xxxx xxxx)
        const masked = formatCardNumber(value);
        formik.setFieldValue(name, masked);

        // 🔥 Validation
        if (!brand) {
            formik.setFieldError(name, "Unknown card type");
            return;
        }

        if (!brand.validLengths.includes(value.length)) {
            formik.setFieldError(name, `Invalid ${brand.name.toUpperCase()} card length`);
            return;
        }

        if (!luhnCheck(value)) {
            formik.setFieldError(name, "Invalid card number");
            return;
        }

        formik.setFieldError(name, "");
    };
    // const handleChange = (e) => {
    //   let raw = e.target.value.replace(/\D/g, ""); // remove spaces

    //   // 1️⃣ Detect brand based on current digits
    //   const brand = detectCardBrand(raw);
    //   setCardBrand(brand);
    //   formik.setFieldValue("cardBrand", brand);

    //   // 2️⃣ Determine valid max length based on brand
    //   const maxLength = brand
    //     ? Math.max(...brand.validLengths)   // brand-specific maximum
    //     : 19; // generic fallback

    //   // 3️⃣ Enforce max allowed digits (BLOCK TYPING beyond range)
    //   if (raw.length > maxLength) {
    //     raw = raw.slice(0, maxLength);
    //   }

    //   // 4️⃣ Format with spaces
    //   const masked = formatCardNumber(raw);
    //   formik.setFieldValue(name, masked);

    //   // 5️⃣ Validation
    //   if (brand) {
    //     const minLength = Math.min(...brand.validLengths);

    //     if (raw.length < minLength) {
    //       formik.setFieldError(name, `${brand.name.toUpperCase()} requires minimum ${minLength} digits`);
    //     } else if (!brand.validLengths.includes(raw.length)) {
    //       formik.setFieldError(name, `Invalid ${brand.name.toUpperCase()} card length`);
    //     } else if (!luhnCheck(raw)) {
    //       formik.setFieldError(name, "Invalid card number");
    //     } else {
    //       formik.setFieldError(name, "");
    //     }
    //   } else {
    //     formik.setFieldError(name, raw.length > 0 ? "Unknown card type" : "");
    //   }
    // };
    //   const handleChange = (e) => {
    //   let value = e.target.value.replace(/\s+/g, ''); // remove spaces
    //     const brand = detectCardBrand(value);
    //     setCardBrand(brand);
    // formik.setFieldValue("cardBrand", brand); 
    //     // Masked formatting
    //     const masked = formatCardNumber(value);
    //     formik.setFieldValue(name, masked);

    //     // Validation
    //     if (brand) {
    //       if (!brand.validLengths.includes(value.length)) {
    //         formik.setFieldError(name, `Invalid ${brand.name.toUpperCase()} card length`);
    //       } else if (!luhnCheck(value)) {
    //         formik.setFieldError(name, "Invalid card number");
    //       } else {
    //         formik.setFieldError(name, "");
    //       }
    //     } else {
    //       formik.setFieldError(name, "Unknown card type");
    //     }
    //   };
    const handleBlur = () => {
        formik.setFieldTouched(name, true); // ✅ Mark field as touched
    };
    return (
        <TextField
            fullWidth
            label={label}
            name={name}
            value={formik.values[name]}
            onChange={handleChange}
            onBlur={handleBlur}
            error={formik.touched[name] && Boolean(formik.errors[name])}
            helperText={formik.touched[name] && formik.errors[name]}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        {cardBrand && <img src={cardBrand.logo} alt={cardBrand.name} style={{ width: 40 }} />}
                    </InputAdornment>
                ),
                style: { height: '35px' }
            }}
        />
    );
}

export default CreditCardInput;
